import { api } from "../../utils/api";
import constant from "../../constant";
const apiUrl = constant.api + "sellers";

const state = {
  sellers: [],
  seller: {},
};

// getters
const getters = {
  getAll: (state) => {
    return state.sellers;
  },

  getSeller: (state) => {
    return state.seller;
  },
};

// actions
const actions = {
  async setSeller({ commit }, data) {
    commit("setSeller", data);
  },

  async getAll({ commit }) {
    const response = await api.get(apiUrl);
    commit("setAll", response);
  },

  async getSeller({ commit }, reference) {
    const response = await api.get(apiUrl + "/" + reference);
    commit("setSeller", response);
  },
};

// mutations
const mutations = {
  async setAll(state, data) {
    return (state.sellers = data);
  },

  async setSeller(state, data) {
    return (state.seller = data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
